import { render, staticRenderFns } from "./InputBox2.vue?vue&type=template&id=7b561e09&scoped=true"
import script from "./InputBox2.vue?vue&type=script&lang=js"
export * from "./InputBox2.vue?vue&type=script&lang=js"
import style0 from "./InputBox2.vue?vue&type=style&index=0&id=7b561e09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b561e09",
  null
  
)

export default component.exports